export default __webpack_public_path__ + "static/media/Mute.0a320399.svg";